import { cn } from '@/app/lib';

export const IMAGE_DIMENSIONS = {
  width: 544,
  height: 544,
  className: cn('xl:w-136 xl:h-136', 'md:w-75 md:h-75', 'w-full h-81.75'),
};

export const VIDEO_DIMENSIONS = {
  width: 595,
  height: 394,
  className: cn('w-full aspect-[327.00/216.53]', 'md:!w-148.75 md:!h-98.5'),
};
